module.exports = __webpack_public_path__ + "static/header-logo-white-xd.3e0bc5d6.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/header-logo-white-xd.png
// module id = 126
// module chunks = 2